/**
 * @author Mukesh kumar bairwa <mukesh.bairwa@314ecorp.com>
 * @description Search query builder Buttons component
 */

import React from 'react';
import { AntdConfig, ButtonProps } from '@react-awesome-query-builder/antd';
import { Button } from 'antd';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import { DeleteOne, Plus } from '@icon-park/react';

interface IProps extends Omit<ButtonProps, 'onClick'> {
	onClick?: () => void;
}

const RenderButtonsComponent: React.FC<IProps> = (props) => {
	const { type, label, readonly, config, onClick } = props;
	const defaultRenderButton: AnyType = AntdConfig.settings.renderButton;
	const size = config?.settings.renderSize as SizeType;

	if (type === 'addRule') {
		return (
			<Button
				color='default'
				className='add-filter-btn'
				disabled={readonly}
				icon={<Plus />}
				key={type}
				onClick={onClick}
				size={size}
				type='link'
				variant='link'
			>
				{label ?? 'Add Filter'}
			</Button>
		);
	}
	if (type === 'addGroup' || type === 'delGroup') {
		return null;
	}
	if (type === 'delRule' || type === 'delRuleGroup') {
		return (
			<Button
				key={type}
				danger
				type='default'
				size={size}
				disabled={readonly}
				icon={<DeleteOne />}
				className='raqb-delete-btn'
				onClick={onClick}
			/>
		);
	}

	return defaultRenderButton?.(props) as React.ReactElement<ButtonProps>;
};

export default RenderButtonsComponent;
